import React, { Component } from 'react';

import RoleComponent from '../components/roleLogin';

export default class Role extends Component {
    render() { 
        const {...props} = this.props
        return (
            <div className='login-root'>
                <div className='bg-login'>
                    <div className='img-inside'></div>
                </div>
                <RoleComponent {...props} />
                {/* <div class='login-role-wapper'>
                    <RoleComponent {...props} />
                </div> */}
            </div>
        )
    }

}

